<script>
import { getChartDataForFinancialPeriod } from '../../api'
// Components
import { baseDonutCmp } from '../baseDonutCmp'

export default {
  provide: {
    chartName: 'share-per-product-type'
  },

  ...baseDonutCmp(getChartDataForFinancialPeriod)
}
</script>
